import * as React from "react";
import {
	addEntriesToCensus,
	addEntriesToCensusByFile,
} from "../data/controllers/CensusCoolerController";
import { uuid } from "../../../../types/veboxModels";
import { DataResponse } from "../data/models/RestApi";
import { CensusCoolerContext } from "./CensusCollerProvider";
import { JSONCensus } from "../data/models/JSONCensus";
import {
	CensusCSVImportResult,
	JSONCensusCSVImportResult,
	JSONCensusCSVImportResultIntoCensusCSVImportResult,
} from "../data/models/JSONCensusCSVImportResult";

interface FindEquipmentContextType {
	addComponentsToCensus: (guidList: uuid[]) => void;
	addEntriesByFile: (file: File) => Promise<JSONCensusCSVImportResult>;
	validatedEntries: CensusCSVImportResult;
	censusWithNewEntities: DataResponse<JSONCensus>;
}

interface ImportEquipmentProvider {
	refreshList: () => Promise<void>;
	fetchFirstEntriesList: () => boolean;
}

export const ImportEquipmentContext =
	React.createContext<FindEquipmentContextType>({} as any);

export const ImportEquipmentProvider: React.FC<ImportEquipmentProvider> = ({
	children,
	refreshList,
	fetchFirstEntriesList,
}) => {
	const { createCensus } = React.useContext(CensusCoolerContext);

	const [validatedEntries, setValidatedEntries] =
		React.useState<CensusCSVImportResult>();

	const [censusWithNewEntities, setCensusWithNewEntities] = React.useState<
		DataResponse<JSONCensus>
	>({ data: undefined, error: undefined, isLoading: false });

	const addComponentsToCensus = async (guidList: uuid[]) => {
		setCensusWithNewEntities({ ...censusWithNewEntities, isLoading: true });
		try {
			const census = await createCensus();
			const response = await addEntriesToCensus(census?.guid, guidList);
			setCensusWithNewEntities({
				...censusWithNewEntities,
				isLoading: false,
				data: response,
			});
			if (!fetchFirstEntriesList()) {
				await refreshList();
			}
		} catch (error) {
			setCensusWithNewEntities({
				...censusWithNewEntities,
				isLoading: false,
				error,
			});
		}
	};

	const addEntriesByFile = async (file: File) => {
		const result = await addEntriesToCensusByFile(file);
		if (result) {
			setValidatedEntries(
				JSONCensusCSVImportResultIntoCensusCSVImportResult(result),
			);
		}
		return result;
	};

	return (
		<ImportEquipmentContext.Provider
			value={{
				addComponentsToCensus,
				addEntriesByFile,
				validatedEntries,
				censusWithNewEntities,
			}}
		>
			{children}
		</ImportEquipmentContext.Provider>
	);
};
